/**
 * Import JSON utility
 * Reads a JSON file and returns the parsed data
 */
export function importJSON<T = unknown>(): Promise<T | null> {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.json';
    
    input.onchange = (e) => {
      const file = (e.target as HTMLInputElement).files?.[0];
      if (!file) {
        resolve(null);
        return;
      }
      
      const reader = new FileReader();
      reader.onload = (event) => {
        try {
          const text = event.target?.result as string;
          const data = JSON.parse(text);
          resolve(data as T);
        } catch (error) {
          console.error('Failed to parse JSON:', error);
          resolve(null);
        }
      };
      reader.onerror = () => {
        console.error('Failed to read file');
        resolve(null);
      };
      reader.readAsText(file);
    };
    
    input.click();
  });
}






